import React, { lazy, useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "../components/loader";
import ProtectedRoute from "./protected";
import ProtectedAuth from "./protectedAuth";
import ProtectedUser from "./protectedUser";
import { UserAPI } from "../api";
// import screens
const OnBoarding = lazy(() => import("../pages/onboarding"));
const LoyaltyProgram = lazy(() => import("../pages/loyaltyProgram"));
const Signup = lazy(() => import("../pages/auth/signup"));
const Login = lazy(() => import("../pages/auth/signin"));
const Dashboard = lazy(() => import("../pages/dashboard/profile"));
const PDFViewer = lazy(() => import("../pages/doc-viewer"));
const Account = lazy(() => import("../pages/auth/updateAccount"));
const NotFound = lazy(() => import("../pages/404"));

export default function AppRoutes() {
  const [isValid, setValid] = useState(true);
  const checkXevoraAPI = async () => {
    let res = await UserAPI.verifyXevoraAPI();
    if (res.status == 200 && res?.data?.valid == true) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  useEffect(() => {
    checkXevoraAPI();
  }, []);

  if (!isValid) {
    return (
      <React.Suspense fallback={<Loader />}>
        <Routes>
          {/* Catch-all route for 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </React.Suspense>
    );
  }

  return (
    <React.Suspense fallback={<Loader />}>
      <Routes>
        {/* <Route
          exact
          path="/"
          element={
            <ProtectedUser>
              <OnBoarding />
            </ProtectedUser>
          }
        /> */}
        <Route exact path="/loyalty-program" element={<LoyaltyProgram />} />
        <Route exact path="/doc-viewer/:id" element={<PDFViewer />} />

        <Route
          exact
          path="/signup"
          element={
            <ProtectedAuth>
              <Signup />
            </ProtectedAuth>
          }
        />
        <Route
          exact
          path="/login"
          element={
            <ProtectedAuth>
              <Login />
            </ProtectedAuth>
          }
        />
        <Route exact path="/*" element={<Dashboard />} />
        <Route
          exact
          path="/account"
          element={
            <ProtectedRoute>
              <Account />
            </ProtectedRoute>
          }
        />
        {/* Catch-all route for 404 */}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </React.Suspense>
  );
}
